import jwt from "jsonwebtoken";

const initState = {
  loaded: true,
  data: jwt.decode(sessionStorage.getItem("kzvb-obleute")),
  error: [],
};

const userReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_USER_REQUEST":
      return {
        ...state,
        loaded: false,
      };
    case "SET_USER_FAILURE":
      return {
        ...state,
        loaded: true,
        error: action.payload,
      };
    case "SET_USER_SUCCESS":
      return {
        ...state,
        loaded: true,
        data: action.payload,
      };
    case "EDIT_USER":
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
